/**
 * Item counts for home feed blocks, shared by the web home loader and the app's block builders so
 * both render the same set — the loader fetches once and the BFF reshapes what it returns.
 */
export const HOME_BLOCK_ARTICLE_COUNTS = {
  /** Top Stories, Terkini, Singapura, Gaya Hidup. */
  DEFAULT: 4,
  /**
   * Malaysia, Dunia, Kaki Jalan, Kaki Makan, DNA Dunia Anak, Pengguna Berdaftar — the app groups
   * these into a single HorizontalThumbnail card (`CARD_SIZES.HORIZONTAL_THUMBNAIL` in
   * `@bff/constants/MobileCardConstants`), but that's an app-only rendering detail; this file is
   * shared with the web loader, so the name here stays neutral rather than naming a shape web has
   * no notion of.
   */
  EXTENDED: 5,
} as const;

/**
 * CaaS query sizes for the web home loader. Separate from HOME_BLOCK_ARTICLE_COUNTS on purpose:
 * those are the display contract the app BFF reads as `itemLimit`, while these are a loader-only
 * concern, sized higher so successive `excludeIds` de-duplication still leaves enough articles to
 * fill a block.
 *
 * Every entry must stay >= its matching HOME_BLOCK_ARTICLE_COUNTS value, or the block renders short
 * and `sliceToLimit` warns on each render.
 */
export const HOME_BLOCK_FETCH_SIZES = {
  /** Blocks displaying HOME_BLOCK_ARTICLE_COUNTS.DEFAULT items. */
  DEFAULT: HOME_BLOCK_ARTICLE_COUNTS.DEFAULT,
  /** Over-fetch for the blocks displaying HOME_BLOCK_ARTICLE_COUNTS.EXTENDED (5) items. */
  EXTENDED: 10,
  /** MyBH quick-news package — web only; the app has no MyBH container. */
  MYBH: 4,
} as const;
